import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postLogin } from '../../api/create';
import { toast } from 'react-toastify';

interface LoginPayload {
  email: string;
  password: string;
}

interface LoginState {
  isLoading: boolean;
  user: any | null; // Replace `any` with a specific type if known
  error: string | null;
}

// Define the initial state
const initialState: LoginState = {
  isLoading: false,
  user: null,
  error: null,
};


// Async thunk for login
export const loginThunk = createAsyncThunk(
  'login/loginUser',
  async (values: LoginPayload, { rejectWithValue }) => {
    try {
      const response = await postLogin(values); // Using postLogin instead of fetch

      if (response?.error) {
        throw new Error(response.error);
      }

      const accessToken = response?.result?.token;
      const loggedUser = response?.result?.user;

      if (accessToken && loggedUser) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('loggedUser', JSON.stringify(loggedUser));
        toast.success("Successfully logged in");
        const isPatientLookupPresent = response?.result?.user?.access?.find((module:any) => module.module_name === 'Patient Lookup');
        if (isPatientLookupPresent){
          setTimeout(() => {
            window.location.href = "/patient-lookup";
          }, 5000);
        } else {
          setTimeout(() => {
            window.location.href = "/account-settings/profile-settings";
          }, 5000);
        }
      } else {
        if (response?.detail){
          toast.error(response?.detail.message);
        } else {
          toast.error('Invalid user credentials')
        }
      }

      return loggedUser; // Assuming `response.records` contains user data
    } catch (error: any) {
      return rejectWithValue(error.message || 'The login attempt failed');
    }
  }
);

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload; // Assuming payload contains user data
        state.error = null;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default loginSlice.reducer;
